import { render, staticRenderFns } from "./PageDict.vue?vue&type=template&id=747aa58c&scoped=true&"
import script from "./PageDict.vue?vue&type=script&lang=js&"
export * from "./PageDict.vue?vue&type=script&lang=js&"
import style0 from "./PageDict.vue?vue&type=style&index=0&id=747aa58c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747aa58c",
  null
  
)

export default component.exports